import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect, ConnectedProps } from 'react-redux';
import { showAllResults, searchNext } from '../../state/actions';
import { StateType } from '../../../state/state.types';

const mapState = ({ results }: StateType) => ({
  showCutMessage: results.resultsWasCut && !results.paginationLoading,
  hiddenResults: results.hiddenResults,
  totalHits: results.totalHits,
  lastResponse: results.lastResponse,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  toggleTopResults() {
    dispatch(showAllResults());
    dispatch(searchNext());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
